/**
 * @generated SignedSource<<8c7d79f4e0f7f5624e97d832dcc197c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutStickySubmitButton_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSubmitButton_buyer">;
  readonly " $fragmentType": "CheckoutStickySubmitButton_buyer";
};
export type CheckoutStickySubmitButton_buyer$key = {
  readonly " $data"?: CheckoutStickySubmitButton_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutStickySubmitButton_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutStickySubmitButton_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSubmitButton_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9c71787bd8d06d00e3ff6c73675adeda";

export default node;
